export default "__VITE_ASSET__BUySIUet__"